<template>
  <div class="seed-recharge">
      <router-link to="/seedrecord">
        <div class="my-seed">
                <p>{{$t('lang.vip.myseed')}}：{{seeds.amount}}</p>
                <img src="../assets/seed_arrow.png"/> 
        </div>
      </router-link>
      <div class="price-wrapper">
          <div class="price-bg" v-for="(item, index) in goodsInfo" :key="index" @click="buySeed(item)">
              <p class="seeds" :class="item.presentSeedAmount==0?'seeds1':''">{{item.seedAmount}}<span class="unit">{{$t('lang.vip.seeds')}}</span></p>
               <div class="present" :class="item.presentSeedAmount==0?'present1':''">
                   <img src="../assets/present.png" v-show="item.presentSeedAmount!=0"/>
                   <span v-show="item.presentSeedAmount!=0">{{$t('lang.vip.present')}}{{item.presentSeedAmount}}{{$t('lang.vip.present1')}}</span>
               </div>
              <div class="price">{{$t('lang.vip.currency')}}{{item.price/100}}</div>
          </div>
      </div>
  </div>
</template>
<script>
import { Uploader, Toast, Loading } from "vant"
import {getShop, getSeeds, postMember} from '@/api/api'
import common from "@/utils/common.js"
import wView from "@/utils/webSDK.js"

export default {
  components: {
    [Uploader.name]: Uploader,
    [Loading.name]: Loading
  },
  data() {
    return {
      shopName: common.getQueryString('shopName'),
      goodsInfo: [],
      selectedIndex: 0,
      userInfo : {},
      btnText: '',
      isiOS: common.isiOS(),
      seeds: 0
    };
  },
  beforeMount: function() {
    this.init();
  },
  methods: {
      init(){
          let that = this
          getSeeds().then(res => {
              that.seeds = res.data
          })
          getShop(that.shopName).then(res => {
            that.goodsInfo = res.data
        })
      },
      buySeed(item){
        let that = this
        let data = {
            "goodsId": item.goodsId,
            "amount": '1',
        }
        let payChannel = common.getQueryString('payChannel')
        if(payChannel ==='apple_iap'){
            payChannel = 'inApp'
        }else{
            payChannel = 'wxpay'
        }
        postMember(data).then(res => {
            if(res.hasOwnProperty('error')) {
                Toast(res.error.message)
                return
            }else{
                wView.payOrder(payChannel, res.data.orderNo,function(response){
                    if(response.resultCode == 0){
                        wView.updateUser()
                        Toast(that.$t('lang.vip.successTip'))
                        setTimeout(function(){
                            getSeeds().then(res => {
                                that.seeds = res.data
                            })
                        }, 500)
                    }else{
                        if (response.resultMessage) {
                            Toast(response.resultMessage)
                        }
                    }
                })
            }
        })
      }
  }
};
</script>
<style lang="less">
.seed-recharge{
    .my-seed{
        font-size:14px;
        color:rgba(24,22,42,1);
        line-height:20px;
        margin: 21px 17px 0 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #E7E9EB;
        img{
            width: 16px;
            float: right;
        }
        p, img{
            display: inline-block;
        }
    }
    .price-wrapper{
        margin: 20px 0 0 2px;
        .price-bg{
            width: 105px;
            height: 115px;
            background: url(../assets/seed_price_bg.png) no-repeat 0% 0% / contain;
            text-align: center;
            margin: 20px 0 0 14px;
            display: inline-block;
            .seeds{
                font-size:24px;
                color:#18162A;
                padding-top: 7px;
                .unit{
                    font-size: 12px;
                    color: #8C8B97;
                }
            }
            .seeds1{
                padding-top: 19px;
            }
            .present{
                font-size:12px;
                color:rgba(52,167,149,1);
                line-height:17px;
                height: 36px;
                img{
                    width: 16px;
                    vertical-align: middle;
                    margin-right: 5px;
                }
            }
            .present1{
                height: 24px;
            }
            .price{
                width:68px;
                height:28px;
                background:linear-gradient(90deg,rgba(115,204,146,1) 0%,rgba(1,164,161,1) 100%);
                border-radius:20px;
                font-size:14px;
                font-family:SFNSDisplay;
                color:rgba(255,255,255,1);
                line-height:28px;
                margin: 0 auto;
            }
        }
        
    }

}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #ccc;
}
input:-moz-placeholder,
textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc;
}
input::-moz-placeholder,
textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc;
}
input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #ccc;
}
// Toast loading
.van-loading-custom {
  background-color: rgba(50, 50, 51, 0);
  .van-loading {
    width: 50px;
    height: 50px;
  }
}
</style>